import { useRouter } from "next/router";
import { useEffect } from "react";

export function Tag({ children }: { children: string }) {
  return <span className="lg:hidden text-her-taggray">{children}: </span>;
}

export function ListSection({ id, children }: { id?: string; children: React.ReactNode }) {
  return (
    <section id={id} className="bg-white dark:bg-her-darkSectionBg shadow-sm py-2 mb-6 rounded-2xl dark:text-slate-300">
      {children}
    </section>
  );
}

interface TabListSectionProps {
  id?: string;
  tabs: { code: string; title: string; list: React.ReactNode }[];
  handleClick: (code: string) => void;
}
export function TabListSection({ id, tabs, handleClick }: TabListSectionProps) {
  const router = useRouter();
  const activeTitle = router.query.tab as string;

  useEffect(() => {
    if (router.isReady && !activeTitle) {
      router.push({
        pathname: router.pathname,
        query: { ...router.query, tab: tabs[0].code },
      });
    }
  }, [router, activeTitle, tabs]);

  return (
    <section>
      <div className="mb-4 flex gap-4">
        {tabs.map((t, idx) => (
          <TabButton key={idx} code={t.code} title={t.title} handleClick={handleClick} isActive={activeTitle === t.code} />
        ))}
      </div>

      {tabs.map((t, idx) =>
        t.code === activeTitle ? (
          <section
            key={idx}
            id={id}
            // className="bg-white dark:bg-her-darkSectionBg shadow-sm py-2 mb-6 rounded-2xl dark:text-slate-300"
          >
            {t.list}
          </section>
        ) : null
      )}
    </section>
  );
}

const TabButton = ({
  code,
  title,
  isActive,
  handleClick,
}: {
  code: string;
  title: string;
  isActive: boolean;
  handleClick: (title: string) => void;
}) => {
  return (
    <button
      onClick={() => handleClick(code)}
      className={`${
        isActive ? "outline outline-her-blue" : ""
      } bg-white  dark:bg-her-darkSectionBg dark:text-white max-w-fit px-8 py-3 rounded-md min-w-32 `}
    >
      {title}
    </button>
  );
};
